import type { AuthenticationFirewallConfiguration } from '../../modules/authenticationFirewall/api';
import type { LogsFilters } from '../../containers/LogsDrawer/types';
import { DIRECTORY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import type { DirectoryType } from '../../containers/LogsDrawer/types';

const getDirectoryTypeFilterValue = (
    excludeDirectoryTypes: string[],
    logsFilters?: LogsFilters
): DirectoryType[] => {
    const defaultExcludedDirectoryTypes: DirectoryType[] = excludeDirectoryTypes.map(
        (dirType) => dirType as DirectoryType
    );

    if (logsFilters?.directoryType && logsFilters.directoryType.length > 0) {
        const excludeBasedOnLogsFilters = Object.values(DIRECTORY_TYPES)
            .map(({ key }) => key)
            .filter((dirType) => !logsFilters.directoryType!.includes(dirType as DirectoryType)) as DirectoryType[];

        return Array.from(new Set([...excludeBasedOnLogsFilters, ...defaultExcludedDirectoryTypes]));
    }

    return defaultExcludedDirectoryTypes;
};

export const getLogsFiltersFromDefaultAuthLogsFilters = (
    authFilters: AuthenticationFirewallConfiguration['authFilters'] | undefined,
    logsFilters?: LogsFilters
): {
    filters: Pick<LogsFilters, 'directoryType' | 'userType' | 'excludeUsers'>;
    excludedFilters?: (keyof LogsFilters)[];
} => {
    if (!authFilters) {
        return {
            filters: {},
            excludedFilters: ['directoryType']
        };
    }

    return {
        filters: {
            directoryType: getDirectoryTypeFilterValue(authFilters.excludeDirectoryTypes, logsFilters),
            userType: authFilters.userType ?? [],
            excludeUsers: authFilters.excludeUserGuids ?? []
        },
        excludedFilters: ['directoryType']
    };
};
